package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.logic.NavigatorBagPage
import com.example.mystybag.appCore.model.pages.FavoritesPageUIState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel
import kotlinx.collections.immutable.ImmutableList

class FavoritesPageViewModel(
    context: AppContext
): ChildViewModel<FavoritesPageUIState>(context, FavoritesPageUIState()) {

    override fun onCreate() {
        navControls.title = sharedString(SR.strings.favorites)
    }
    
    override fun onResume() {
        // Request refresh from MainViewModel when page becomes visible
        // This ensures favorites are up-to-date after adding/removing favorites
        (parentCallbacks as? HomePageCallbacks)?.refreshBags()
    }
    
    /**
     * Зарежда данните за любимите торби от подадения списък
     * Извиква се от MainViewModel след като данните се заредят и филтрират
     */
    fun loadFavoritesData(favorites: ImmutableList<HomeTopPickUiModel>?) {
        updateState { state ->
            state.copy(
                favorites = favorites ?: kotlinx.collections.immutable.persistentListOf(),
                isLoading = false
            )
        }
    }
    
    fun onTopPickClick(item: HomeTopPickUiModel) {
        navigate(NavigatorBagPage(bagItem = item))
    }

    /** Called when user taps the heart on a favorite card to remove it from favorites. */
    fun onRemoveFavorite(item: HomeTopPickUiModel) {
        (parentCallbacks as? HomePageCallbacks)?.removeFavorite(item)
    }
}

